import React, { useState, useEffect, useRef } from 'react';
import './EnrolNow.css';
import './BookTrail.css';
import axios from "axios";
import Swal from 'sweetalert2';
import HolidayNotice from './holidayNotice';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Autocomplete from "react-google-autocomplete";
import locationIcon from '../Image/location.png';
import { areas } from "../Centers/areas";

const termsData = {
  title: "Coaching Trial Policy",
  sections: [
    {
      heading: "1. Trial Fee",
      content: "All coaching trials are chargeable. The applicable fee will be shown at the time of booking."
    },
    {
      heading: "2. Adjustment of Trial Fee",
      content: "The trial fee will be adjusted against the purchase of a coaching plan for the same sport by the same user (applicable once per user per sport)."
    },
    {
      heading: "3. Booking Confirmation",
      content: "Trial booking is confirmed only after successful payment."
    },
    {
      heading: "4. Non-Refundable",
      content: "Trial fee is non-refundable in case of cancellation or no-show."
    },
    {
      heading: "5. Rescheduling",
      content: "One-time rescheduling is permitted, subject to slot availability."
    },
    {
      heading: "6. Validity",
      content: "Trial is valid only for the selected centre, date and time."
    },
    {
      heading: "7. Centre Rules",
      content: "Users must follow all safety, hygiene, and facility guidelines."
    }
  ]
};

const BookTrial = () => {
  const [userName, setUserName] = useState('');
  const [isCreatingNewChild, setIsCreatingNewChild] = useState(false);
  const [selectedChildId, setSelectedChildId] = useState(null);
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const [holidayName, setHolidayName] = useState(null);
  const [showCreateChildInput, setShowCreateChildInput] = useState(false);
  const [newChildName, setNewChildName] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState('');
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [availableSlots, setAvailableSlots] = useState([]);
  const selectWrapperRef = useRef(null);
  const [centers, setCenters] = useState([]);
  const [selectedTrialDate, setSelectedTrialDate] = useState('');
  const [selectedTrialTime, setSelectedTrialTime] = useState('');
  const [parentUserId, setParentUserId] = useState(null);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpLoading, setIsOtpLoading] = useState(false);
  const [errorMessages, setErrorMessages] = useState({
    userName: '',
    contactNumber: '',
    selectedCenter: '',
    selectedTrialTime: '',
    otp: '',
    child: '',
    userCategory: '',
    proficiencyLevel: '',
    termsAccepted: ''
  });

  const [userDetails, setUserDetails] = useState(null);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);
  const [userCategory, setUserCategory] = useState('');
  const [proficiencyLevel, setProficiencyLevel] = useState('');
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [locationLoading, setLocationLoading] = useState(false);
  const [slotAmount, setSlotAmount] = useState(null);
  const [isTermsAccepted, setIsTermsAccepted] = useState(true);
  const [showTermsModal, setShowTermsModal] = useState(false);


  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  };

  const getLocationName = async (latitude, longitude) => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
      );

      if (response.data.results && response.data.results.length > 0) {
        const formattedAddress = response.data.results[0].formatted_address;
        setSearchValue(formattedAddress);
      }

      const sorted = centers
        .map(center => ({
          ...center,
          distance: calculateDistance(
            latitude,
            longitude,
            center.latitude,
            center.longitude
          )
        }))
        .sort((a, b) => a.distance - b.distance);

      setCenters(sorted);
    } catch (err) {
      console.error("Geocoding error:", err);
      Swal.fire('Error', 'Failed to fetch your address.', 'error');
    }
  };

  const updateLocation = async () => {
    if (!navigator.geolocation) {
      Swal.fire('Error', 'Geolocation is not supported.', 'error');
      return;
    }

    setLocationLoading(true);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        getLocationName(latitude, longitude);
        setLocationLoading(false);
      },
      (error) => {
        setLocationLoading(false);

        let msg = 'Location access denied.';
        if (error.code === 1) msg = 'Please enable location permissions in your Browser and System Settings.';
        if (error.code === 2) msg = 'Location unavailable. Try searching manually.';
        if (error.code === 3) msg = 'Location request timed out.';

        Swal.fire('Location Error', msg, 'error');
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0
      }
    );
  };

  const handleLocationSearch = (place) => {
    if (place.geometry) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      setSearchValue(place.formatted_address);

      const sorted = centers
        .map(center => ({
          ...center,
          distance: calculateDistance(lat, lng, center.latitude, center.longitude)
        }))
        .sort((a, b) => a.distance - b.distance);

      setCenters(sorted);
    }
  };

  const handleCenterSelect = (center) => {
    setSelectedCenter(center);
    setSelectedTrialDate('');
    setSelectedTrialTime('');
    setAvailableSlots([]);
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedCenter: '',
      selectedTrialDate: '',
      selectedTrialTime: ''
    }));
    setSlotAmount(null);
  };

  const handleCategoryChange = (category) => {
    setUserCategory(category);
    setErrorMessages((prevErrors) => ({ ...prevErrors, userCategory: '' })); // Clear error
  };

  const handleProficiencyChange = (level) => {
    setProficiencyLevel(level);
    setErrorMessages((prevErrors) => ({ ...prevErrors, proficiencyLevel: '' })); // Clear error
  };

  useEffect(() => {
    if (centers.length > 0) {
      updateLocation();
    }
  }, [centers.length]);

  useEffect(() => {
    setSelectedTrialDate('');
    setSelectedTrialTime('');
    setAvailableSlots([]);
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedTrialDate: '',
      selectedTrialTime: '',
    }));
    setSlotAmount(null);
  }, [userCategory]);

  useEffect(() => {
    setSelectedTrialDate('');
    setSelectedTrialTime('');
    setAvailableSlots([]);
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedTrialDate: '',
      selectedTrialTime: '',
    }));
    setSlotAmount(null);
  }, [proficiencyLevel]);

  useEffect(() => {
    if (contactNumber) {
      setIsOtpVerified(false);
      setOtp('');
      setUserName('');
      setUserDetails(null);
      setShowOtpInput(false);
      setIsNewUser(false);
      setErrorMessages({
        userName: '',
        contactNumber: '',
        selectedCenter: null,
        selectedTrialTime: '',
        otp: '',
        child: '',
        userCategory: '',
        proficiencyLevel: '',
        termsAccepted: '',
      });
    }
  }, [contactNumber]);

  const fetchSportsCenters = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_API_URL_CENTER, {
        method: 'GET', // Adjust method if needed
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_API_KEY,
        }
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch sports centers.');
      }

      const defaultImages = [
        "https://imgmediagumlet.lbb.in/media/2022/01/61efa39514a08c2400a7ce56_1643094933277.png",
        "https://i.ytimg.com/vi/K8RGq4xtJbg/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLAnvqqpSN_Z3Gha4COeOk9un1cj8Q",
        "https://www.scai.in/wp-content/uploads/2023/06/DSC2954-scaled.jpg"
      ];
      const centersData = Object.values(data.sportsToAcademiesMap.Badminton).flat().filter(center => center.id !== 115 && center.id !== 81 && center.id !== 86);
      const academyImages = data.academyImages || {};

      setCenters(
        centersData.map(center => {
          const academyId = center?.id;
          const sports = data.academiesToSportsMap[academyId] || [];
          const areaCenter = areas.flatMap(area => area.centers).find(ac => ac.id === academyId);
          return {
            id: center.id,
            name: center.name,
            latitude: Number(center.latitude) || 0,
            longitude: Number(center.longitude) || 0,
            address: center.address || '',
            images: academyImages[academyId] || defaultImages,
            mapUrl: areaCenter ? areaCenter.location : '#',
            sports: sports.map(sport => sport.sport_name) || [],
          }
        })
      );

    } catch (error) {
      console.error('Error fetching data:', error);
      showBackendError(error);
    }
  };

  useEffect(() => {
    fetchSportsCenters();
  }, []);


  useEffect(() => {

  }, [selectedChildId]);



  const handleCenterChange = (centerName) => {
    const selectedCenterData = centers.find(center => center.name === centerName);
    setSelectedCenter(centerName);
    setSelectedTrialTime('');
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedCenter: '',
      selectedTrialTime: ''
    }));
  };

  const fetchUserDetails = async (mobileNumber) => {
    try {
      const formattedMobileNumber = mobileNumber.startsWith('+91') ? mobileNumber : '+91' + mobileNumber;
      const response = await fetch(process.env.REACT_APP_API_URL_FETCH_USER, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_API_KEY,
        },

        body: JSON.stringify({ mobileNumber: formattedMobileNumber }),
      });

      const data = await response.json();
      console.log("User Details:", data);
      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch user details.');
      }
      if (data && data.userDetails.success) {
        const isParentNew = data.userDetails.parent.name === null;
        setUserDetails(data.userDetails);
        if (isParentNew) setIsNewUser(true);
        setSelectedChildId(null);

      } else {
        setUserDetails(null);
        setIsNewUser(true);
        setSelectedChildId(null);
      }
    } catch (error) {
      setIsNewUser(true);
      setSelectedChildId(null);
      console.error("Error fetching user details:", error);
    }
  };

  const handleChildSelect = (child) => {
    if (child.isParent) {
      setSelectedChildId('parent');
      setParentUserId(userDetails.parent.id);
      setUserName(child.name);
      setIsCreatingNewChild(false);
    } else {
      setSelectedChildId(child.id);
      setParentUserId(null);
      setUserName(child.name);
      setIsCreatingNewChild(false);
    }

    setErrorMessages((prevErrors) => ({ ...prevErrors, child: '' })); // Clear error
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form fields
    let errors = {
      userName: !userName.trim() ? 'Name is required' : '',
      contactNumber: !contactNumber.trim() || !isContactNumberValid ? 'Please enter a valid contact number' : '',
      selectedCenter: !selectedCenter ? 'Please select a center' : '',
      selectedTrialDate: !selectedTrialDate ? 'Please select a date' : '',
      selectedTrialTime: !selectedTrialTime ? 'Please select a trial time' : '',
      otp: !isOtpVerified ? 'Please verify OTP before submitting' : '',
      child: !userName.trim() ? 'Please select or create a child' : '',
      userCategory: !userCategory.trim() ? 'Please select a Category' : '', // Validate userCategory
      proficiencyLevel: !proficiencyLevel.trim() ? 'Please select a Proficiency Level' : '', // Validate proficiencyLevel
      termsAccepted: !isTermsAccepted ? 'Please accept the Terms & Conditions' : '',
    };

    const hasErrors = Object.values(errors).some((error) => error !== '');

    if (hasErrors) {
      setErrorMessages(errors);
      return;
    }

    const slotsData = await fetchAvailableSlots();
    if (!slotsData) return;
    const isReschedule = slotsData?.isReschedule || false;
    const isRescheduleLimitError = slotsData?.isRescheduleLimitError || false;
    if (isRescheduleLimitError) return;
    try {
      const bookingData = {
        userName,
        contactNumber,
        selectedCenter,
        selectedTrialDate: formatDate(selectedTrialDate),
        selectedTrialTime,
        selectedChildId,
        amount: isReschedule ? 0 : slotAmount,
        isReschedule
      };

      setFormData(bookingData);
      setShowConfirmationModal(true);
    } catch (error) {
      console.error('Error during form submission:', error);
      setErrorMessages({ api: 'Failed to process the booking' });
      showBackendError(error);
    }
  };

  const handleOtpVerification = async () => {
    try {
      const formattedContactNumber = contactNumber.startsWith('+91') ? contactNumber : `+91${contactNumber}`;
      const response = await axios.post(process.env.REACT_APP_API_URL_OTP_VERIFY, {
        data: {
          phone_number: formattedContactNumber,
          has_firebase_check: false,
          otp: otp,
        },
      });

      if (response.data.success) {
        setIsOtpVerified(true);

      } else {
        setErrorMessages((prevErrors) => ({
          ...prevErrors,
          otp: response.data.message || 'Invalid OTP, please try again',
        }));
        Swal.fire({
          icon: 'error',
          title: 'Invalid OTP',
          text: response.data.message || 'The OTP you entered is invalid. Please try again.',
        });
      }
    } catch (error) {
      setErrorMessages((prevErrors) => ({
        ...prevErrors,
        otp: 'Failed to verify OTP. Please try again.',
      }));
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to verify OTP. Please try again.',
      });
    }
  };

  const handleInputChange = (e, field) => {
    const value = e.target.value;
    setErrorMessages((prevErrors) => ({ ...prevErrors, [field]: '' }));

    if (field === 'userName') {
      setUserName(value);
    } else if (field === 'contactNumber') {
      setContactNumber(value);
      setIsOtpVerified(false);
      setIsOtpSent(false);
    } else if (field === 'otp') {
      setOtp(value);
    }
  };
  const handleSendOtpClick = async () => {
    const formattedContactNumber = contactNumber.startsWith('+91') ? contactNumber : `+91${contactNumber}`;

    try {
      setIsOtpLoading(true);

      const response = await axios.post(process.env.REACT_APP_API_URL_OTP_SEND, {
        data: {
          phone_number: formattedContactNumber,
          has_firebase_check: false,
        },
      });

      if (response.data.success) {
        setShowOtpInput(true);
        setIsOtpVerified(false);
        setOtp('');
        setIsOtpSent(true);

        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: `OTP sent to ${formattedContactNumber} via WhatsApp and SMS. Please enter it to proceed.`,
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });

        await fetchUserDetails(contactNumber);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed to Send OTP',
          text: response.data.message || 'Something went wrong. Please try again.',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to send OTP. Please try again.',
      });
    } finally {
      setIsOtpLoading(false);
    }
  };

  function formatDate(date) {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formattedDate = new Date(date).toLocaleDateString('en-US', options);
    return formattedDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$02-$01-$03');
  }
  const calculateDaysDifference = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const timeDifference = end - start;
    const daysDifference = timeDifference / (1000 * 3600 * 24);
    return Math.abs(Math.floor(daysDifference));
  };



  const handleTrialTimeChange = (time, batchId, status) => {
    if (status === 'Available') {
      setSelectedTrialTime(time);
      setSelectedBatchId(batchId);

      setErrorMessages((prevErrors) => ({ ...prevErrors, selectedTrialTime: '' }));
    }
  };



  const isContactNumberValid = /^[0-9]{10}$/.test(contactNumber);

  const ConfirmationModal = ({ showModal, onClose, onConfirm, bookingData, selectedBatchId }) => {
    if (!showModal) return null;

    const handleConfirm = async () => {
      try {
        let parentIdToSend = null;
        let childIdToSend = null;
        let isChildBooking = userCategory === "Kids";
        console.log("DEBUGU - userCategory", userCategory);

        if (newChildName) {
          console.log("DEBUG - in new child");
          parentIdToSend = userDetails?.parent?.id || null;
          childIdToSend = null;
        } else if (selectedChildId === 'parent') {
          console.log("DEBUG - parent is selected");
          parentIdToSend = userDetails?.parent?.id || null;
          childIdToSend = parentUserId;
        } else if (selectedChildId) {
          console.log("DEBUG - child is selected");
          parentIdToSend = userDetails?.parent?.id || null;
          childIdToSend = selectedChildId;
        }
        //  else if (userDetails && !selectedChildId) {
        //   // If no child is selected and userDetails is present, assume the parent is selecting itself
        //   parentIdToSend = userDetails?.parent?.id || null;
        //   childIdToSend = userDetails?.parent?.id || null; // Set child ID to parent ID
        // }
        else {
          console.log("DEBUG - else case");
          // Default case, set both IDs to null
          parentIdToSend = userDetails?.parent?.id || null;
          childIdToSend = null;
        }

        // Find the selected center's academy_id
        const academyIdToSend = bookingData.selectedCenter?.id || null;

        const formattedMobileNumber = bookingData.contactNumber.startsWith('+91')
          ? bookingData.contactNumber
          : '+91' + bookingData.contactNumber;

        const formattedProficiencyLevel = proficiencyLevel.toUpperCase();
        const bookingAmount = Number(bookingData.amount);

        // Reschedules are free and should use the reschedule API directly.
        if (bookingAmount === 0 && bookingData.isReschedule) {
          console.log("DEBUG - Reschedule amount is 0, directly rescheduling without payment");

          const reschedulePayload = {
            isPlayingTrial: 0,
            isCoachingTrial: 1,
            user_id: isChildBooking ? childIdToSend : parentIdToSend,
            name: bookingData.userName,
            email: null,
            mobile_number: formattedMobileNumber,
            gender_type: "female", // Default value, can be updated as needed
            sport_id: 1,
            academy_id_new: academyIdToSend,
            academy_id_prev: academyIdToSend,
            start_time: bookingData.selectedTrialTime.split(" - ")[0],
            end_time: bookingData.selectedTrialTime.split(" - ")[1],
            booking_date: formatDateToYYYYMMDD(bookingData.selectedTrialDate),
            area: null,
            source: "Badminton_Coaching",
            batch_id: selectedBatchId
          };

          console.log("DEBUG - Reschedule Payload:", reschedulePayload);

          const rescheduleResponse = await axios.post(
            'https://admin.machaxi.com/summer-api/trial/reschedule-trial2',
            reschedulePayload,
            {
              headers: {
                'Content-Type': 'application/json',
                'x-api-key': 'jNtunfkUwiAT4YXgQacG84SXO0ZRrzCxSnyUaFunqg',
              }
            }
          );

          console.log("DEBUG - Reschedule Response:", rescheduleResponse.data);
          const rescheduleSuccess = typeof (rescheduleResponse?.data?.message) === "string" && rescheduleResponse?.data?.message === "Trial rescheduled Successfully";

          if (rescheduleSuccess) {
            Swal.fire({
              icon: 'success',
              title: 'Booking Confirmed!',
              text: 'Your trial has been successfully booked.',
            }).then(() => {
              window.location.href = '/SuccessPage';
              sessionStorage.setItem('paymentStatus', 'success');
              sessionStorage.setItem('message', 'Your trial has been rescheduled successfully.');
              onClose();
              setContactNumber('');
              setIsOtpVerified(false);
              setOtp('');
              setShowOtpInput(false);
            });
          } else {
            throw new Error(rescheduleResponse.data.message || 'Failed to book trial. Please try again.');
          }
          return;
        }

        // Free non-reschedule slots should create a booking directly without Razorpay.
        if (bookingAmount === 0 && !bookingData.isReschedule) {
          console.log("DEBUG - Amount is 0, directly creating booking without payment");

          const selectedSlot = { slot: { batch_id: selectedBatchId } };
          const selectedSport = { id: 1 }; // Badminton sport ID
          
          const directBookingPayload = {
            parent_id: parentIdToSend || (isChildBooking ? null : userDetails?.parent?.id),
            user_id: isChildBooking ? childIdToSend : parentIdToSend,
            name: bookingData.userName,
            email: null,
            mobile_number: normalizePhoneNumber(bookingData.contactNumber, true),
            gender_type: "Male", // Gender not available in current context
            academy_id: selectedCenter?.id,
            sport_id: selectedSport?.id,
            start_time: formatApiTime(bookingData.selectedTrialTime?.split(" - ")[0], true),
            end_time: formatApiTime(bookingData.selectedTrialTime?.split(" - ")[1], true),
            booking_date: getBookingDate(),
            area: selectedCenter?.address || null,
            source: "Badminton_Coaching",
            proficiency: proficiencyLevel?.toLowerCase() === "beginner" ? "BASIC" : proficiencyLevel?.toUpperCase() || "BASIC",
            payment_id: null,
            amount: 0,
            batch_id: selectedSlot?.slot?.batch_id,
          };

          console.log("DEBUG - Direct Booking Payload:", directBookingPayload);

          const SUMMER_API_BASE_URL = "https://admin.machaxi.com/summer-api";
          const apiUrl = `${SUMMER_API_BASE_URL}/trial/create-coaching-trial2`;
          
          const directBookingResponse = await axios.post(
            apiUrl,
            directBookingPayload,
            {
              headers: {
                'Content-Type': 'application/json',
                'x-api-key': process.env.REACT_APP_API_KEY,
              }
            }
          );

          console.log("DEBUG - Direct Booking Response:", directBookingResponse.data);

          const directBookingSuccess = directBookingResponse?.data?.success !== false;

          if (directBookingSuccess) {
            Swal.fire({
              icon: 'success',
              title: 'Booking Confirmed!',
              text: 'Your trial has been successfully booked.',
            }).then(() => {
              window.location.href = '/SuccessPage';
              sessionStorage.setItem('paymentStatus', 'success');
              sessionStorage.setItem('message', 'Your trial has been successfully booked.');
              onClose();
              setContactNumber('');
              setIsOtpVerified(false);
              setOtp('');
              setShowOtpInput(false);
            });
          } else {
            throw new Error(directBookingResponse.data.message || 'Failed to book trial. Please try again.');
          }
          return;
        }

        // Validate Slots (only for paid bookings)
        const validateSlotsPayload = {
          parent_id: parentIdToSend,
          user_id: isChildBooking ? childIdToSend : parentIdToSend,
          name: bookingData.userName,
          mobile_number: formattedMobileNumber,
          source: "Badminton_Coaching",
          academy_id: academyIdToSend,
          batch_id: selectedBatchId,
          sport_id: 1,
          booking_date: formatDateToYYYYMMDD(bookingData.selectedTrialDate),
          amount: bookingData.amount,
          payment_id: null,
          start_time: bookingData.selectedTrialTime.split(" - ")[0],
          end_time: bookingData.selectedTrialTime.split(" - ")[1],
          area: selectedCenter.name,
        }

        const validateResponse = await axios.post(process.env.REACT_APP_API_URL_VALIDATE_SLOTS,
          validateSlotsPayload,
          {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': process.env.REACT_APP_API_KEY,
            }
          }
        );

        console.log("DEBUG - Slot validation response:", validateResponse);
        if (validateResponse?.data?.result?.isValid) {
          console.log("DEBUG - Slot validation successful:", validateResponse.data.message);
        } else {
          throw new Error(validateResponse.data.message || 'Selected slot is no longer available. Please choose a different slot.');
        }

        // Create Razorpay order
        const razorpayPayload = {
          amount: bookingData.amount * 100,
          currency: 'INR',
          receipt: `receipt_${Date.now()}`,
          paymentType: 'learn',
        }

        const razorpayOrder = await axios.post(
          process.env.REACT_APP_API_URL_ORDER_ID,
          razorpayPayload,
          {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': process.env.REACT_APP_API_KEY,
            }
          }
        );

        if (!razorpayOrder.data || !razorpayOrder.data.id) {
          throw new Error('Failed to create Razorpay order. Please try again.');
        }

        console.log("DEBUG - Razorpay Order Response:", razorpayOrder.data);
        const razorpayOrderId = razorpayOrder.data.id;

        // Create backend order

        const backendOrderPayload = {
          userId: parentIdToSend,
          orderDetails: [{
            academy: academyIdToSend,
            amount: bookingData.amount, // Amount in INR
            amountAfterDiscount: bookingData.amount, // Amount in INR
            discountAmount: 0,
            gstAmount: 0,
            payableAmount: bookingData.amount, // Amount in INR
            paymentId: null,
            regRenFees: null,
            regRenType: null,
            isCoaching: true,
            isRenewal: false,
            isTrial: true,
            rpOrderId: razorpayOrderId,
          }]
        }

        console.log("DEBUG - Backend Order Payload:", backendOrderPayload);

        const backendOrderResponse = await axios.post(process.env.REACT_APP_API_URL_CREATE_ORDER,
          backendOrderPayload,
          {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': process.env.REACT_APP_NODE_API_KEY,

            }
          }
        );

        if (!backendOrderResponse.data || !backendOrderResponse.data.data || !backendOrderResponse.data.data[0] || !backendOrderResponse.data.data[0].orderId) {
          throw new Error('Failed to create backend order. Please try again.');
        }

        console.log("DEBUG - Backend Order Response:", backendOrderResponse.data);
        const backendOrderId = backendOrderResponse.data.data?.[0].orderId;

        //Create Pre-Order details for Razorpay Webhook
        const preOrderPayload = {
          parent_id: parentIdToSend,
          user_id: isChildBooking ? childIdToSend : parentIdToSend,
          name: bookingData.userName,
          mobile_number: `+91${bookingData.contactNumber}`,
          gender_type: "Male",
          batch_id: selectedBatchId,
          academy_id: academyIdToSend,
          sport_id: 1,
          start_time: bookingData.selectedTrialTime.split(" - ")[0],
          end_time: bookingData.selectedTrialTime.split(" - ")[1],
          booking_date: formatDateToYYYYMMDD(bookingData.selectedTrialDate),
          proficiency: formattedProficiencyLevel,
          area: selectedCenter.name,
          source: "Badminton_Coaching",
          is_coaching: true,
          discount: 0,
          amount: bookingData.amount,
          final_payable_amount: bookingData.amount,
          coupon_code: null,
          order_id: backendOrderId,
          rz_order_id: razorpayOrderId,
          isCoaching: 0
        }

        console.log("DEBUG - Pre-Order Payload:", preOrderPayload);

        const preOrderResponse = await axios.post(process.env.REACT_APP_API_URL_CREATE_PRE_ORDER,
          preOrderPayload,
          {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': process.env.REACT_APP_API_KEY,
            }
          }
        );

        console.log("DEBUG - preOrderResponse", preOrderResponse.data);


        // take payment
        const razorpay = new window.Razorpay({
          key: process.env.REACT_APP_API_RAZORPAY_KEY,
          amount: razorpayOrder.data.amount,
          currency: razorpayOrder.data.currency,
          order_id: razorpayOrder.data.id,
          name: 'Machaxi Badminton Coaching Trial',
          description: `Booking - ${userDetails.parent.name || userName}, MN:${bookingData.contactNumber}`,

          handler: async function (response) {
            console.log('Razorpay payment success response:', response);

            if (
              response.razorpay_payment_id &&
              response.razorpay_order_id &&
              response.razorpay_signature
            ) {
              console.log("DEBUG - Payment successful, verifying order status with backend...");
              const verificationPayload = {
                orderId: razorpayOrderId
              }
              try {
                const verifyResponse = await axios.post(process.env.REACT_APP_API_URL_VERIFY_ORDER_STATUS,
                  verificationPayload,
                  {
                    headers: {
                      'Content-Type': 'application/json',
                      'x-api-key': process.env.REACT_APP_NODE_API_KEY,
                    }
                  }
                );
                console.log("DEBUG - Verify Payment Response:", verifyResponse.data);
                if (verifyResponse.data.success) {
                  window.location.href = '/SuccessPage';
                  sessionStorage.setItem('paymentStatus', 'success');
                  sessionStorage.setItem('message', 'Your trial has been successfully booked.');
                  onClose();
                  setContactNumber('');
                  setIsOtpVerified(false);
                  setOtp('');
                  setShowOtpInput(false);
                } else {
                  throw new Error(verifyResponse.data.message || 'Payment verification failed');
                }
              } catch (err) {
                console.log('Error inside verifyPayment handler:', err);
                Swal.fire({
                  icon: 'error',
                  title: 'Payment Verification Failed',
                  text: err.message || 'Your payment was successful, but we could not verify it. Please contact support with your payment details.',
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 5000,
                  timerProgressBar: true
                });
              }
            }
          },

          modal: {
            ondismiss: function () {

              Swal.fire({
                icon: 'info',
                title: 'Payment Cancelled',
                text: 'If amount is deducted, please contact support.',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
              });
            }
          },

          prefill: {
            name: userDetails?.parent?.name || userName,
            contact: bookingData.contactNumber,
          },

          theme: {
            color: '#322978'
          }
        });

        razorpay.on('payment.failed', function (err) {
          console.log('Razorpay payment.failed event:', err);

          Swal.fire({
            icon: 'error',
            title: 'Payment Failed',
            text: 'Please try again. If amount is deducted, contact support.',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 4000
          });
        });

        razorpay.open();
      } catch (error) {
        console.error('Error during confirmation:', error);

        let errorMessage = 'Failed to process the booking';

        // Check if error response exists and extract the message
        if (error.response && error.response.data) {
          errorMessage = error.response.data.message || JSON.stringify(error.response.data);
        } else if (error.message) {
          errorMessage = error.message;
        }

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: errorMessage,
        });
      }
    };
    const formatDateToYYYYMMDD = (dateString) => {
      const [day, month, year] = dateString.split('-');

      const date = new Date(`${year}-${month}-${day}`);
      if (isNaN(date.getTime())) {
        console.error("Invalid date string:", dateString);
        return "Invalid Date";
      }

      const formattedYear = date.getFullYear();
      const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
      const formattedDay = String(date.getDate()).padStart(2, '0');

      return `${formattedYear}-${formattedMonth}-${formattedDay}`;
    };

    const [start, end] = bookingData.selectedTrialTime.split(' - ');

    return (
      <div className="confirmation-modal-overlay">
        <div className="modal-content">
          <button className="close-btn" onClick={onClose}>
            <span className="close-icon">&times;</span>
          </button>

          <h3 className="modal-title">Confirm Your Trial</h3>
          <div className="booking-summary">
            <p><strong>Name:</strong> {bookingData.userName}</p>
            <p><strong>Contact Number:</strong> {bookingData.contactNumber}</p>
            <p><strong>Center:</strong> {bookingData.selectedCenter?.name}</p>
            <p><strong>Trial Date:</strong> {bookingData.selectedTrialDate}</p>
            <p><strong>Time Slot:</strong> {formatTo12Hour(start)}-{formatTo12Hour(end)}</p>
            {bookingData.isReschedule && (
              <p className="reschedule-note">
                This is a rescheduled booking, so no payment is required.
              </p>
            )}
            <p className="booking-amount-row">
              <strong>Payable Amount:</strong> <span className="booking-amount">₹{bookingData.amount}</span>
            </p>
          </div>
          <p className="trial-note">
            {bookingData.amount === 0 ? 'No online payment is required. Your booking will be confirmed directly.' : '*This one-time fee will be adjusted against your swimming plan purchase'}
          </p>
          <div className="modal-actions">
            <button onClick={handleConfirm} className="btn-confirm">
              {Number(bookingData.amount) === 0
                ? bookingData.isReschedule ? 'Confirm Reschedule' : 'Confirm Booking'
                : `Pay ₹${bookingData.amount}`}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const showBackendError = (error) => {
    let errorMessage = 'Something went wrong. Please try again.';

    // Extract error message from backend response
    if (error.response && error.response.data && error.response.data.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }

    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: errorMessage,
    });
  };

  const handleDateChange = (date) => {
    setHolidayName(null);
    setSelectedTrialDate(date);
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedTrialDate: '',
    }));
  };
  useEffect(() => {
    if (selectedTrialDate && selectedCenter) {
      fetchAvailableSlots();
    }
  }, [selectedTrialDate, selectedCenter]);

  const handleHolidayResponse = (data) => {
    if (data?.is_holiday !== true) return false;

    setAvailableSlots([]);
    setSelectedTrialTime('');
    setSelectedBatchId(null);
    setSlotAmount(null);
    setHolidayName(data.holiday_description || 'Holiday');
    return true;
  };

  const fetchAvailableSlots = async () => {
    setHolidayName(null);
    try {
      if (!selectedCenter?.id) {
        throw new Error('Selected center not found.');
      }

      const formattedDate = formatDateToYYYYMMDD(selectedTrialDate);
      console.log("DEBUG - selectedChildId", selectedChildId);
      // Determine user_id to send
      let userIdToSend = null;
      if (selectedChildId === 'parent') {
        userIdToSend = parentUserId;
      } else if (selectedChildId) {
        userIdToSend = selectedChildId;
      }

      const payload = {
        isPlaying: 0,
        isCoaching: 1,
        academy_id: selectedCenter.id,
        sport_id: 1,
        batch_type: userCategory === 'Adult' ? "ADULTS" : "KIDS", // Use the selected category
        proficiency_type: proficiencyLevel.toUpperCase(), // Use the selected proficiency level
        booking_date: formattedDate,
        user_id: userIdToSend,
      };

      console.log("DEBUG - payload", payload);

      const response = await axios.post(
        process.env.REACT_APP_API_URL_SLOT_CHECK,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': process.env.REACT_APP_API_KEY,
          }
        }
      );

      if (handleHolidayResponse(response.data)) return null;

      if (response.data.message === 'Available Playing slots fetched successfully !') {
        setAvailableSlots(response.data.availableCoachingSlots);
        setSlotAmount(response.data.amount);
        const isReschedule = response.data?.is_reschedule;
        return { isReschedule };
      } else if (response.data.message === 'Rescheduling limit exceeded' && !response.data.success) {
        // Handle rescheduling limit exceeded case
        Swal.fire({
          icon: 'warning',
          title: 'Rescheduling Limit Exceeded',
          text: response.data.message || 'You have reached the maximum number of rescheduling attempts.',
        });
        setAvailableSlots([]);
        setSlotAmount(null);
        return null;
      } else {
        throw new Error(response.data.message || 'Failed to fetch available slots.');
      }
    } catch (error) {
      if (handleHolidayResponse(error?.response?.data)) return null;

      console.error('Error fetching available slots:', error);
      const rescheduleLimitError = typeof (error?.response?.data?.message) === "string" && error?.response?.data?.message === "Rescheduling limit exceeded";
      if (rescheduleLimitError) {
        setAvailableSlots([]);
        setSlotAmount(null);
        Swal.fire({
          icon: 'warning',
          title: 'Rescheduling Limit Exceeded',
          text: 'You have reached the maximum number of rescheduling attempts. Please contact support for assistance.',
          confirmButtonColor: '#322978'
        });
        const isRescheduleLimitError = true;
        return {
          isRescheduleLimitError
        };
      }
      showBackendError(error);
      return null;
    }
  };

  const normalizePhoneNumber = (phoneNumber, includePlus = false) => {
    const cleaned = phoneNumber.replace(/[^0-9]/g, '');
    if (cleaned.length === 10) {
      return includePlus ? `+91${cleaned}` : cleaned;
    }
    if (cleaned.startsWith('91') && cleaned.length === 12) {
      return includePlus ? `+${cleaned}` : cleaned.substring(2);
    }
    return includePlus ? `+91${cleaned}` : cleaned;
  };

  const formatApiTime = (timeString, is24Hour = false) => {
    if (!timeString) return null;
    
    // If time is already in HH:MM format, return as is
    if (/^\d{2}:\d{2}$/.test(timeString)) {
      return timeString;
    }
    
    // Handle time range format like "09:00 AM - 10:00 AM"
    if (timeString.includes(' - ')) {
      const startTime = timeString.split(' - ')[0];
      return formatApiTime(startTime, is24Hour);
    }
    
    // Convert 12-hour format to 24-hour format
    const timeMatch = timeString.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
    if (timeMatch) {
      let [, hours, minutes, period] = timeMatch;
      hours = parseInt(hours);
      
      if (period.toUpperCase() === 'PM' && hours !== 12) {
        hours += 12;
      } else if (period.toUpperCase() === 'AM' && hours === 12) {
        hours = 0;
      }
      
      return `${hours.toString().padStart(2, '0')}:${minutes}`;
    }
    
    return timeString;
  };

  const getBookingDate = () => {
    return formatDateToYYYYMMDD(selectedTrialDate);
  };

  const formatDateToYYYYMMDD = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const formatTo12Hour = (time) => {
    if (!time) return '';

    const [hour, minute] = time.split(':');
    let h = parseInt(hour, 10);
    const ampm = h >= 12 ? 'PM' : 'AM';

    h = h % 12;
    h = h ? h : 12; // 0 becomes 12

    return `${h}:${minute} ${ampm}`;
  };

  useEffect(() => {
    setSelectedTrialTime(null);
  }, [selectedTrialDate]);

  const TermsModal = ({ show, onClose, data, onAgree }) => {
    if (!show) return null;

    return (
      <div className="terms-modal-overlay" onClick={onClose}>
        <div className="terms-modal-box" onClick={(e) => e.stopPropagation()}>
          <button className="terms-modal-close" onClick={onClose}>
            &times;
          </button>

          <h3 className="terms-modal-title">{data?.title || "Terms & Conditions"}</h3>

          <div className="terms-modal-body">
            {data?.sections?.length ? (
              data.sections.map((section, index) => (
                <div key={index} className="terms-section">
                  <h4>{section.heading}</h4>
                  <p>{section.content}</p>
                </div>
              ))
            ) : (
              <p>No terms available.</p>
            )}
          </div>
          <div className="terms-modal-footer">
            <button
              className="terms-agree-btn"
              onClick={() => {
                onAgree();
                onClose();
              }}
            >
              I Agree
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="book-trial-container">
      <h2 className="rescedule-title">
        Book Trial
      </h2>
      <form className="booking-form" onSubmit={handleSubmit}>

        <div className="location-search-section-trial">
          <label className="trial-time-label">Search Your Location</label>
          <div className="search-bar-wrapper">
            <Autocomplete
              apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
              className="location-search-input-booking"
              onPlaceSelected={handleLocationSearch}
              options={{
                types: ["geocode", "establishment"],
                componentRestrictions: { country: "in" },
              }}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder="Search area, street or building..."
            />

            <button
              type="button"
              className={`current-location-btn ${locationLoading ? 'loading' : ''}`}
              onClick={updateLocation}
            >
              <img src={locationIcon} alt="Loc" className="geo-icon" />
            </button>
          </div>
        </div>

        <div className="centers-list-container">
          <label className="trial-time-label">Select Centre:</label>

          {locationLoading ? (
            <div>
              <p>Fetching location...</p>
            </div>
          ) :
            (<div className="centers-details-row">
              {centers.map((center) => (
                <div
                  key={center.id}
                  className={`mini-center-card ${selectedCenter?.id === center.id ? 'active-card' : ''}`}
                  onClick={() => handleCenterSelect(center)}
                >
                  <div className="image-container-mini">
                    <div className="sports-overlay-bar-mini">
                      {center.sports.slice(0, 2).map((sport, idx) => (
                        <div key={idx} className="sport-tag-container">
                          <span className="sport-name-label-mini">{sport}</span>
                        </div>
                      ))}
                    </div>

                    <img src={center.images[0]} alt={center.name} className="center-image-mini" />

                    {center.distance && (
                      <div className="distance-badge-mini">
                        {center.distance.toFixed(1)} km away
                      </div>
                    )}
                  </div>

                  <div className="info-container-mini">
                    <div className="text-content">
                      <h3 className="center-name-mini">{center.name}</h3>
                      {/* Added Address Display */}
                      <p className="center-address-mini">{center.address}</p>

                      <a
                        href={center.mapUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="view-map-link-mini"
                        onClick={(e) => e.stopPropagation()}
                      >
                        View on Map
                      </a>
                    </div>

                    <button type="button" className="select-center-btn-mini">
                      {selectedCenter?.id === center.id ? 'SELECTED' : 'SELECT CENTRE'}
                    </button>
                  </div>
                </div>
              ))}
            </div>)}
          {errorMessages.selectedCenter && <p className="error">{errorMessages.selectedCenter}</p>}
        </div>

        {selectedCenter && (
          <div className="trial-time-picker">
            <label className="trial-time-label">Category:</label>
            <div className="trial-time-options">
              <button
                type="button"
                className={`trial-time-option ${userCategory === 'Adult' ? 'selected' : ''}`}
                onClick={() => handleCategoryChange('Adult')}
              >
                Adult
              </button>
              <button
                type="button"
                className={`trial-time-option ${userCategory === 'Kids' ? 'selected' : ''}`}
                onClick={() => handleCategoryChange('Kids')}
              >
                Kids
              </button>
            </div>
            {errorMessages.userCategory && <p className="error">{errorMessages.userCategory}</p>}
          </div>
        )}

        {selectedCenter && (
          <div className="trial-time-picker">
            <label className="trial-time-label">Proficiency Level:</label>
            <div className="trial-time-options">
              <button
                type="button"
                className={`trial-time-option ${proficiencyLevel === 'Basic' ? 'selected' : ''}`}
                onClick={() => handleProficiencyChange('Basic')}
              >
                Beginner
              </button>
              <button
                type="button"
                className={`trial-time-option ${proficiencyLevel === 'Intermediate' ? 'selected' : ''}`}
                onClick={() => handleProficiencyChange('Intermediate')}
              >
                Intermediate
              </button>
              <button
                type="button"
                className={`trial-time-option ${proficiencyLevel === 'Advanced' ? 'selected' : ''}`}
                onClick={() => handleProficiencyChange('Advanced')}
              >
                Advance
              </button>
            </div>
            {errorMessages.proficiencyLevel && <p className="error">{errorMessages.proficiencyLevel}</p>}
          </div>
        )}


        {selectedCenter && (
          <div><label className="form-date">Trial Date:</label></div>
        )}
        {selectedCenter && (

          <div className="floating-select">


            <DatePicker
              className={`sales-filter-academy ${selectedTrialDate ? 'has-value' : ''}`}
              selected={selectedTrialDate}
              onChange={handleDateChange}
              minDate={new Date()}
              dateFormat="dd/MM/yyyy"
              placeholderText="Select trial date"
              required
              inline
            // excludeDates={[new Date(2026, 2, 21), new Date(2026, 2, 19)]} // Specifically block March 21, 2026 and March 19, 2026
            />
            {holidayName && <HolidayNotice name={holidayName} />}
            {errorMessages.selectedTrialDate && (
              <p className="error">{errorMessages.selectedTrialDate}</p>
            )}
          </div>
        )}

        {slotAmount !== null && (
          <div className="slot-amount-box">
            <span className="slot-amount-label">Trial Fee</span>
            <span className="slot-amount-value">₹{slotAmount}</span>
          </div>
        )}

        {selectedTrialDate && !holidayName && (
          <div className="trial-time-picker">
            <label className="trial-time-label">Time Slot:</label>
            <div className="trial-time-options">
              {availableSlots.length > 0 ? (
                availableSlots.map((slot, index) => {
                  const startTime = slot.start_time ? slot.start_time.slice(0, 5) : 'N/A';
                  const endTime = slot.end_time ? slot.end_time.slice(0, 5) : 'N/A';
                  const isAvailable = slot.status === 'Available';

                  return (
                    <button
                      key={index}
                      type='button'
                      className={`trial-time-option ${selectedTrialTime === `${startTime} - ${endTime}` ? 'selected' : ''
                        } ${!isAvailable ? 'disabled' : ''}`}
                      onClick={() =>
                        handleTrialTimeChange(`${startTime} - ${endTime}`, slot.batch_id, slot.status)
                      }
                      disabled={!isAvailable}
                    >
                      <div>
                        {formatTo12Hour(startTime)} - {formatTo12Hour(endTime)}
                      </div>
                      <div>{slot.status}</div>
                    </button>
                  );
                })
              ) : (
                <p className="no-time-slot">No Time Slots Available</p>
              )}
            </div>

            {errorMessages.selectedTrialTime && (
              <p className="error">{errorMessages.selectedTrialTime}</p>
            )}
          </div>
        )}
        <div className="floating-select">
          <input
            className={`sales-filter-academy ${contactNumber ? 'has-value' : ''}`}
            type="tel"
            value={contactNumber}
            onChange={(e) => handleInputChange(e, 'contactNumber')}
            onKeyPress={(e) => {
              if (!/^[0-9]$/.test(e.key)) {
                e.preventDefault();
              }
            }}
            maxLength={10}
            placeholder="Enter 10-digit phone number"
          />

          {contactNumber && <label htmlFor="contactNumber">Contact Number</label>}
          {errorMessages.contactNumber && <p className="error">{errorMessages.contactNumber}</p>}
          {errorMessages.otp && <p className="error">{errorMessages.otp}</p>}
          {isOtpVerified && (
            <span className="checkmark">✓</span>
          )}

          {!showOtpInput && !isOtpVerified && isContactNumberValid && (
            <button
              type="button"
              onClick={handleSendOtpClick}
              className="btn-send-otp"
              disabled={isOtpLoading || isOtpSent}
            >
              {isOtpLoading
                ? "Sending..."
                : isOtpSent
                  ? "OTP Sent"
                  : "Send OTP"}
            </button>
          )}
        </div>

        {showOtpInput && !isOtpVerified && (
          <div className="floating-select">
            <input
              className={`sales-filter-academy ${otp ? 'has-value' : ''}`}
              type="text"
              value={otp}
              onChange={(e) => handleInputChange(e, 'otp')}
              maxLength={6}
              placeholder="Enter OTP"
            />
            <button type="button" onClick={handleOtpVerification} className="btn-send-otp">
              Verify OTP
            </button>
          </div>
        )}

        {isNewUser && isOtpVerified && (
          <div className="floating-select">
            <input
              className={`sales-filter-academy ${userName ? 'has-value' : ''}`}
              type="text"
              value={userName}
              onChange={(e) => handleInputChange(e, 'userName')}
              placeholder="Enter your name"
            />
            {userName && <label htmlFor="userName">Name</label>}
            {errorMessages.userName && <p className="error">{errorMessages.userName}</p>}
          </div>
        )}

        {isOtpVerified && !isNewUser && userDetails && (
          <div className="floating-select-child" ref={selectWrapperRef}>
            <label htmlFor="child" className="selectchild">Select User</label>

            <div className={`sales-filter-academy ${userName ? 'has-value' : ''}`}>
              {/* Radio Buttons for Existing Children */}
              <div className="custom-options">
                {/* Add Parent as an option */}

                {userCategory === "Adult" && <div
                  className={`custom-option ${selectedChildId === null && !isCreatingNewChild ? 'selected' : ''}`}
                  onClick={() => handleChildSelect({ isParent: true, name: userDetails.parent.name })}
                >
                  <input
                    type="radio"
                    checked={selectedChildId === 'parent'}

                    readOnly
                    className="radio-dot"
                  />
                  <span>{userDetails.parent.name}</span>
                </div>}

                {userDetails.children.map((child, index) => (
                  <div
                    key={index}
                    className={`custom-option ${selectedChildId === child.id ? 'selected' : ''}`}
                    onClick={() => handleChildSelect(child)}
                  >
                    <input
                      type="radio"
                      checked={selectedChildId === child.id}
                      readOnly
                      className="radio-dot"
                    />
                    <span>{child.name}</span>
                  </div>
                ))}
              </div>

              {showCreateChildInput ? (
                <div className="floating-select">
                  <input
                    className={`sales-filter-academy ${newChildName ? 'has-value' : ''}`}
                    type="text"
                    value={newChildName}
                    onChange={(e) => setNewChildName(e.target.value)}
                    placeholder="Enter child's name"
                    onClick={(e) => e.stopPropagation()}
                  />
                  {newChildName && <label htmlFor="newChildName">User's Name</label>}

                  <button
                    type="button"
                    className="btn-send-otp"
                    onClick={() => {
                      if (newChildName.trim()) {
                        // Check if a child with null ID already exists
                        const existingNewChildIndex = userDetails.children.findIndex(
                          (child) => child.id === null
                        );

                        if (existingNewChildIndex !== -1) {
                          // Update existing child's name
                          const updatedChildren = [...userDetails.children];
                          updatedChildren[existingNewChildIndex].name = newChildName;
                          setUserDetails((prevDetails) => ({
                            ...prevDetails,
                            children: updatedChildren,
                          }));
                        } else {
                          // Create new child
                          const newChild = {
                            id: null,
                            name: newChildName,
                          };
                          setUserDetails((prevDetails) => ({
                            ...prevDetails,
                            children: [...prevDetails.children, newChild],
                          }));
                          setIsCreatingNewChild(true);
                        }

                        // Clear input & close form
                        setUserName(newChildName);
                        setSelectedChildId(null);
                        setShowCreateChildInput(false);

                        // Show success message
                        Swal.fire({
                          text: `Child "${newChildName}" saved!`,
                          icon: 'success',
                          confirmButtonText: 'OK',
                        });
                      } else {
                        Swal.fire({
                          title: 'Error!',
                          text: 'Please enter a name for the child.',
                          icon: 'error',
                          confirmButtonText: 'OK',
                        });
                      }
                    }}
                  >
                    {userDetails.children.some((child) => child.id === null)
                      ? 'Save User'
                      : 'Save User'}
                  </button>
                </div>
              ) : (
                <div className="create-new-child-container">
                  <button
                    type="button"
                    className="btn-create-child"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowCreateChildInput(true);
                    }}
                  >
                    {userDetails.children.some((child) => child.id === null)
                      ? 'Add User'
                      : 'Add User'}
                  </button>
                </div>
              )}
            </div>

            {errorMessages.child && <p className="error">{errorMessages.child}</p>}
          </div>
        )}

        <div className="terms-checkbox-wrapper">
          <label className="terms-checkbox-label">
            <input
              type="checkbox"
              checked={isTermsAccepted}
              onChange={(e) => {
                setIsTermsAccepted(e.target.checked);
                setErrorMessages((prev) => ({ ...prev, termsAccepted: '' }));
              }}
            />
            <span>
              I agree to{" "}
              <button
                type="button"
                className="terms-link-btn"
                onClick={() => setShowTermsModal(true)}
              >
                Terms & Conditions
              </button>
            </span>
          </label>

          {errorMessages.termsAccepted && (
            <p className="error">{errorMessages.termsAccepted}</p>
          )}
        </div>

        <div className="form-group">
          <button className="form-button" type="submit">Proceed</button>

        </div>

        <ConfirmationModal
          showModal={showConfirmationModal}
          onClose={() => setShowConfirmationModal(false)}
          selectedBatchId={selectedBatchId}
          onConfirm={() => {
            alert('Booking Confirmed!');
            setShowConfirmationModal(false);

          }}
          bookingData={formData}
        />

        <TermsModal
          show={showTermsModal}
          onClose={() => setShowTermsModal(false)}
          data={termsData}
          onAgree={() => {
            setIsTermsAccepted(true);
            setErrorMessages((prev) => ({ ...prev, termsAccepted: '' }));
          }}
        />
      </form>
    </div>
  );
};

export default BookTrial;
